let slideIndex = 0;
showSlides();


function showSlides() {
  let i;
  let slides = document.getElementsByClassName("slides");
  let lines = document.getElementsByClassName("line");

  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";  
  }

  for (i = 0; i < lines.length; i++) {
    lines[i].className = lines[i].className.replace(" active-slide", "");
  }

  // Increment active index, in case it is out of bounds it will be reset to 1
  slideIndex++;
  if (slideIndex > slides.length) {slideIndex = 1} 

  if(slides[slideIndex-1]){
  // Show the new active slide
  slides[slideIndex-1].style.display = "block";
  lines[slideIndex-1].className += " active-slide";
  }
  setTimeout(showSlides, 2000);
}



// WEBPACK FOOTER //
// ./scripts/custom/image-carousel.js